import { render } from "./MyBindEs.vue?vue&type=template&id=4381c50c&scoped=true"
import script from "./MyBindEs.vue?vue&type=script&lang=js"
export * from "./MyBindEs.vue?vue&type=script&lang=js"

import "./MyBindEs.vue?vue&type=style&index=0&id=4381c50c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4381c50c"]])

export default __exports__